

import  {Button}  from '../../components/ui/button';

import SectionHeading from '../../components/common/SectionHeading';

export default function CTASection() {
  return (
    <section className="bg-primary text-background section-padding">
      <div className="container-safe text-center">
        <SectionHeading
          title="Ready to grow your business?"
          description="Join the pros already using MrJoe.Pro to get paperwork done fast and keep more profit."
          descriptionClassName="text-bg-page-accent-soft"
        />

{/** 
        <p className="text-bg-page-accent-soft mt-2 text-xs max-md:hidden">
          3 Months free trial • No credit card required • Cancel anytime
        </p>
        */}
      </div>
    </section>
  );
}

